import React, {Component} from 'react';
import {Button} from 'react-bootstrap';
import {DialogActions} from "@material-ui/core";
import RemotingService from "../../services/remoting-service/RemotingService";
import DateUtil from "../../utils/DateUtil";

const TYPE_LABELS = {
    INSURANCE_COMPANY_MISMATCH:        "Insurance Company Mismatch",
    POLICY_NUMBER_MISMATCH:            "Policy Number Mismatch",
    MEMBER_ID_MISMATCH:                "Member ID Mismatch",
    COVERAGE_EFFECTIVE_DATE_MISMATCH:  "Coverage Effective Date Mismatch",
    EXPIRY_DATE_MISMATCH:              "Expiry Date Mismatch",
};

class EligibilityAlertsModal extends Component {

    state = {
        alerts: [],
    };

    componentDidMount() {
        this.fetchAlerts();
    }

    fetchAlerts = () => {
        const {patientId} = this.props;
        if (!patientId) return;
        RemotingService.getRemoteCall(`api/eligibility-alert/${patientId}/alerts`, null, (alerts) => {
            this.setState({alerts: alerts || []});
        });
    };

    handleResolve = (alertId) => {
        RemotingService.postRemoteCall(
            `api/eligibility-alert/${alertId}/resolve`,
            null,
            () => {
                this.fetchAlerts();
                if (this.props.onAlertResolved) {
                    this.props.onAlertResolved();
                }
            }
        );
    };

    renderAlertRow = (alert) => {
        const isUnresolved = alert.status === "UNRESOLVED";

        return (
            <tr key={alert.id} style={{borderBottom: "1px solid #e5e5e5"}}>
                <td style={{padding: "8px", verticalAlign: "top"}}>
                    <strong>{TYPE_LABELS[alert.type] || alert.type || "-"}</strong>
                    <div style={{color: "#666", fontSize: "12px"}}>
                        {alert.creationDate ? DateUtil.formatDateMMM(alert.creationDate) : ""}
                    </div>
                </td>
                <td style={{padding: "8px", verticalAlign: "top"}}>
                    <pre style={{whiteSpace: "pre-wrap", margin: 0, fontFamily: "inherit"}}>
                        {alert.details || "-"}
                    </pre>
                </td>
                <td style={{padding: "8px", verticalAlign: "top"}}>
                    {isUnresolved ? (
                        <Button size="sm" variant="primary" onClick={() => this.handleResolve(alert.id)}>
                            Resolve
                        </Button>
                    ) : (
                        <div style={{color: "#2f7d2f"}}>
                            <strong>Resolved</strong>
                            {alert.resolvedAt && (
                                <div style={{fontSize: "12px", color: "#666"}}>
                                    {DateUtil.formatDateMMM(alert.resolvedAt)}
                                    {alert.resolvedBy?.name ? ` by ${alert.resolvedBy.name}` : ""}
                                </div>
                            )}
                        </div>
                    )}
                </td>
            </tr>
        );
    };

    render() {
        const {alerts} = this.state;

        return (
            <>
                <div style={{padding: "0 8px 8px 8px", minWidth: 600}}>
                    {alerts.length === 0 ? (
                        <div style={{padding: 16, textAlign: "center", color: "#666"}}>
                            No eligibility alerts for this patient.
                        </div>
                    ) : (
                        <table style={{width: "100%"}}>
                            <thead>
                            <tr style={{borderBottom: "2px solid #ccc", textAlign: "left"}}>
                                <th style={{padding: "8px", width: "25%"}}>Type</th>
                                <th style={{padding: "8px", width: "50%"}}>Details</th>
                                <th style={{padding: "8px", width: "25%"}}>Action</th>
                            </tr>
                            </thead>
                            <tbody>{alerts.map(this.renderAlertRow)}</tbody>
                        </table>
                    )}
                </div>
                <DialogActions>
                    <Button variant="secondary" onClick={() => this.props.close && this.props.close()}>Close</Button>
                </DialogActions>
            </>
        );
    }
}

export default EligibilityAlertsModal;
